// Base URL for assets on the Yardzen public-images CDN (not in the repo).
//
// The CDN host is the R2 public-images custom domain, which is env-prefixed
// (infra/aws/terraform/r2.tf: `${env}-cdn-images.yardzen.com`). This is the
// client-side twin of the API's PUBLIC_IMAGES_CDN_BASE_URL — the NEXT_PUBLIC_
// prefix is required because the value is inlined into the browser bundle, so
// it must be set at BUILD time (build_next_app.sh writes secretfile values into
// apps/build-marketplace/.env before `nx build`), not at runtime.
//
// Falls back to prod so local dev and any un-provisioned env still render
// images rather than broken thumbnails.
export const PUBLIC_IMAGES_CDN_BASE_URL = (
  process.env.NEXT_PUBLIC_IMAGES_CDN_BASE_URL ||
  "https://prod-cdn-images.yardzen.com"
).replace(/\/+$/, "");

export const BRAND_LOGO_CDN_BASE =
  "https://prod-cdn-images.yardzen.com/brand-logos";
